import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Share2, Box, ArrowRight, Zap, ShieldCheck, BarChart3, CreditCard, LucideShoppingCart } from 'lucide-react';
import Section from '../Section';
import GradualSpacingText from '../GradualSpacingText/GradualSpacingText';
import './Solutions.css';

const features = [
    { title: "Dry-Van Experts", desc: "Specialized in non-perishable freight.", icon: <Box />, color: "blue" },
    { title: "Nationwide FTL", desc: "Full truckload coverage across the U.S.", icon: <Share2 />, color: "purple" },
    { title: "24/7 Support", desc: "Dispatchers available round the clock.", icon: <TrendingUp />, color: "orange" },
    { title: "GPS Tracking", desc: "Real-time visibility on every load.", icon: <Zap />, color: "blue" },
    { title: "Safety First", desc: "FMCSA compliant and fully insured.", icon: <ShieldCheck />, color: "purple" },
    { title: "On-Time Delivery", desc: "Performance driven logistics solutions.", icon: <BarChart3 />, color: "orange" },
    { title: "Dedicated Lanes", desc: "Consistent capacity for your core routes.", icon: <Box />, color: "blue" },
    { title: "Scalable Fleet", desc: "Flexible capacity for seasonal surges.", icon: <Share2 />, color: "orange" },
    { title: "Secure Handling", desc: "Cargo protection and expert loading.", icon: <ShieldCheck />, color: "blue" },
    { title: "Broker Support", desc: "Seamless partnership for 3PL providers.", icon: <TrendingUp />, color: "purple" },
];

const Solutions = () => {
    // Duplicate the list to create a seamless loop
    const marqueeItems = [...features, ...features];

    return (
        <Section className="solution-features-section">
            <div className="marquee-container">
                <motion.div
                    className="marquee-track"
                    animate={{ x: [0, -2000] }} // Adjust based on your content width
                    transition={{
                        x: {
                            repeat: Infinity,
                            repeatType: "loop",
                            duration: 30, // Lower = Faster
                            ease: "linear",
                        },
                    }}
                    whileHover={{ transition: { duration: 60 } }} // Slows down on hover
                >
                    {marqueeItems.map((feature, index) => (
                        <div key={index} className={`marquee-card ${feature.color}`}>
                            <div className="icon-wrapper">{feature.icon}</div>
                            <div className="card-body">
                                <h3>{feature.title}</h3>
                            </div>
                        </div>
                    ))}
                </motion.div>

                {/* Gradient Overlays for Fade Effect */}
                <div className="marquee-fade-left"></div>
                <div className="marquee-fade-right"></div>
            </div>
        </Section>
    );
};

export default Solutions;